import { render, staticRenderFns } from "./ReservationData.vue?vue&type=template&id=271a6756&scoped=true"
import script from "./ReservationData.vue?vue&type=script&lang=js"
export * from "./ReservationData.vue?vue&type=script&lang=js"
import style0 from "./ReservationData.vue?vue&type=style&index=0&id=271a6756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "271a6756",
  null
  
)

export default component.exports